import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TeamData {
  id: number;
  areaName: string;
}

export interface TeamResponse {
  success: boolean;
  message: string;
  data: TeamData[];
}

interface TeamState {
  teams: TeamData[];
  message: string;
  success: boolean;
}

const initialState: TeamState = {
  teams: [],
  message: "",
  success: false,
};

const teamSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {
    loadTeams(state, action: PayloadAction<TeamResponse>) {
      state.teams = action.payload.data;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    diMissTeams(state) {
      state.teams = [];
      state.message = "";
      state.success = false;
    }
  }
});

export const { loadTeams, diMissTeams } = teamSlice.actions;

export default teamSlice.reducer;
